import axios from 'axios';
import { api } from './main';

export default {
  getCategories() {
    return api({
      method: 'GET',
      data: null,
      url: '/api/v1/categoria'
    });
  },
  getServices(category) {
    return api({
      method: 'GET',
      data: null,
      url: `/api/v1/categoria/${category}/servico`
    });
  },
  listService(service) {
    return api({
      method: 'GET',
      data: null,
      url: `api/v1/servico/${service}`
    });
  },
  listServicePlaces(service) {
    return api({
      method: 'GET',
      data: null,
      url: `api/v1/servico/${service}/unidades`
    });
  },
  datesWithAvailableSchedule(service) {
    return api({
      method: 'GET',
      data: null,
      url: `api/v1/servico/${service}/datas`
    });
  },
  datesWithAvailableScheduleOfPlace(service, place, appointmentType) {
    return api({
      method: 'GET',
      data: null,
      url: `api/v1/servico/${service}/unidade/${place}/datas?tipo=${appointmentType}`
    });
  },
  numberOfAvailableHoursOfAPlace(service, appointmentType) {
    return api({
      method: 'GET',
      data: null,
      url: `api/v1/servico/${service}/total-horarios?tipo=${appointmentType}`
    });
  },
  availableDateSchedule(service, date) {
    return api({
      method: 'GET',
      data: null,
      url: `api/v1/servico/${service}/horario?${date}`
    });
  },
  availableDateScheduleOfPlace(service, date, place, appointmentType) {
    return api({
      method: 'GET',
      data: null,
      url: `api/v1/servico/${service}/unidade/${place}/horario?dia=${date}&tipo=${appointmentType}&sort=data&order=asc`
    });
  },
  avaiableScheduleDetails(service, date, place) {
    return api({
      method: 'GET',
      data: null,
      url: `api/v1/servico/${service}/unidade/${place}/horario/${date}`
    });
  },
  fetchSvg(svgUrl) {
    return axios.get(svgUrl, {
      responseType: 'text'
    });
  },
  postAppointment({ service, place, hour }, data) {
    return api({
      method: 'POST',
      url: `api/v1/servico/${service.id}/unidade/${place.id}/horario/${hour.id}`,
      data: data,
    });
  },
  confirmAppointment(appointmentId) {
    return api({
      method: 'POST',
      data: null,
      url: `/api/v1/agendamento/${appointmentId}/confirmar`,
    });
  }
};
